import {Typography,Box} from '@mui/material';
import WebTheme from "./WebTheme";
import './../../CSS/Estilo.css';

export function CajaTexto({marginLeft,margintop,estiloPagina,icon,texto,altoLetra}){
    return(
        <Typography variant="body1"
                    sx={{
                        fontFamily: 'arial',
                        whiteSpace:'pre-line',
                        textAlign:'left',
                        fontWeight: 700,
                        letterSpacing: '.2rem',
                        fontSize: altoLetra?altoLetra:'1.5em',
                        textDecoration: 'none',
                        width:'90%',
                        ml:(marginLeft)?marginLeft:'5%',
                        mt:(margintop)?margintop:'3%',
                        display:'block',
                        color: (estiloPagina && estiloPagina.background === 'black')?
                            WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
                    }}>
            {icon && icon}
            {texto}
        </Typography>
    )
}

export function CajaTextoLectura({icon,textAlign,marginLeft,estiloPagina,texto}){
    return(
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {icon && <Box sx={{ mr: 1 }}>{icon}</Box>}
            <Typography
                variant="body1"
                align={textAlign ?? 'center'}
                sx={{
                    fontFamily: 'arial',
                    textAlign:'justify',
                    fontWeight: 500,
                    letterSpacing: '.2rem',
                    fontSize: '1.5em',
                    textDecoration: 'none',
                    ml:(marginLeft)?marginLeft:'0px',
                    width:'98%',
                    display:'block',
                    color: (estiloPagina && estiloPagina.background === 'black')?
                        WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
                }}
                dangerouslySetInnerHTML={{ __html: texto }}
            />
        </Box>
    )
}

export function CajaTextoMediano({icon,textAlign,marginLeft,estiloPagina,texto}){
    return(
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {icon && <Box sx={{ mr: 1 }}>{icon}</Box>}
        <Typography
            variant="body1"
            align={(textAlign)?textAlign:'center'}
            sx={{
                fontFamily: 'arial',
                fontWeight: 700,
                letterSpacing: '.3rem',
                fontSize: '2.2em',
                textDecoration: 'none',
                ml:(marginLeft)?marginLeft:'0px',
                width:'100%',
                display:'block',
                //backgroundColor:'red',
                color: (estiloPagina && estiloPagina.background === 'black')?
                    WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
            }}  dangerouslySetInnerHTML={{ __html: texto }}>
        </Typography>
        </Box>
    )
}
export function RotuloWebMediano({textAlign,marginLeft,marginBottom,estiloPagina,icon,texto})
{
    return(
        <Typography
            variant="h7"
            noWrap
            sx={{
                fontFamily: 'arial',
                fontWeight: 700,
                letterSpacing: '.3rem',
                fontSize: '2em',
                textDecoration: 'underline',
                textAlign:(textAlign)?textAlign:'center',
                ml:(marginLeft)?marginLeft:'0px',
                mb:(marginBottom)?marginBottom:'0px',
                width:'100%',
                display:'block',
                color: (estiloPagina && estiloPagina.background === 'black')?
                    WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
            }}>
            {icon && icon}
            {texto}
        </Typography>
    );
}

export function RotuloWebPequeno({textAlign,marginLeft,marginBottom,estiloPagina,icon,texto})
{
    return (
        <Typography
            variant="h7"
            noWrap
            sx={{
                fontFamily: 'arial',
                fontWeight: 700,
                letterSpacing: '.3rem',
                fontSize: '2em',
                textDecoration: 'underline',
                textAlign:(textAlign)?textAlign:'center',
                ml:(marginLeft)?marginLeft:'0px',
                mb:(marginBottom)?marginBottom:'0px',
                width:'100%',
                display:'block',
                color: (estiloPagina.background === 'black') ? WebTheme.colors.letraDark : WebTheme.colors.letraGreenRotulo
            }}>
            {icon && icon}
            {texto}
        </Typography>
    );
}

